"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ActionTypes = require("../../actionTypes/info");
const status_1 = require("../../status");
const initialState = {
    status: status_1.RequestStatusFactory.fetch.standby(),
    error: null,
    buildInfo: null
};
const methods = {};
methods[ActionTypes.BuildInfo.REQUEST] = (state) => (Object.assign(Object.assign({}, state), { status: status_1.RequestStatusFactory.fetch.busy(), error: null }));
methods[ActionTypes.BuildInfo.SUCCESS] = (state, action) => (Object.assign(Object.assign({}, state), { buildInfo: action.payload, status: status_1.RequestStatusFactory.fetch.success(), error: null }));
methods[ActionTypes.BuildInfo.FAILURE] = (state, action) => (Object.assign(Object.assign({}, state), { status: status_1.RequestStatusFactory.fetch.failure(), error: action.error }));
exports.default = (state = initialState, action) => (methods[action.type] ? methods[action.type](state, action) : state);
//# sourceMappingURL=index.js.map